'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  onSearch: (query: string) => void;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, className = '' }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  const handleClear = () => {
    setSearchQuery('');
    onSearch('');
  };

  return (
    <form data-component-id="src/app/news-updates/components/SearchBar.tsx:25:4" data-component-path="src/app/news-updates/components/SearchBar.tsx" data-component-line="25" data-component-file="SearchBar.tsx" data-component-name="form" data-component-content="%7B%22elementName%22%3A%22form%22%7D" onSubmit={handleSubmit} className={`relative ${className}`}>
      <div data-component-id="src/app/news-updates/components/SearchBar.tsx:26:6" data-component-path="src/app/news-updates/components/SearchBar.tsx" data-component-line="26" data-component-file="SearchBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
        <Icon data-component-id="src/app/news-updates/components/SearchBar.tsx:27:8" data-component-path="src/app/news-updates/components/SearchBar.tsx" data-component-line="27" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%2C%22className%22%3A%22absolute%20left-4%20top-1%2F2%20-translate-y-1%2F2%20text-muted-foreground%22%7D"
          name="MagnifyingGlassIcon"
          size={20}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
        <input data-component-id="src/app/news-updates/components/SearchBar.tsx:32:8" data-component-path="src/app/news-updates/components/SearchBar.tsx" data-component-line="32" data-component-file="SearchBar.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AsearchQuery%5D%22%2C%22className%22%3A%22w-full%20pl-12%20pr-12%20py-3%20bg-card%20border%20border-border%20rounded-lg%20text-foreground%20placeholder-muted-foreground%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-primary%20focus%3Aborder-transparent%20transition-smooth%22%7D"
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Pretražite vijesti..."
          className="w-full pl-12 pr-12 py-3 bg-card border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
        />
        {searchQuery && (
          <button data-component-id="src/app/news-updates/components/SearchBar.tsx:40:10" data-component-path="src/app/news-updates/components/SearchBar.tsx" data-component-line="40" data-component-file="SearchBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-4%20top-1%2F2%20-translate-y-1%2F2%20text-muted-foreground%20hover%3Atext-foreground%20transition-smooth%22%7D"
            type="button"
            onClick={handleClear}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-smooth"
          >
            <Icon data-component-id="src/app/news-updates/components/SearchBar.tsx:45:12" data-component-path="src/app/news-updates/components/SearchBar.tsx" data-component-line="45" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={20} />
          </button>
        )}
      </div>
    </form>
  );
};

export default SearchBar;